import { AxiosError } from "axios";
import useSWR from "swr";

import useSWRMutation from "swr/mutation";
import axiosInstance from "../axios";
import { CbtDetails, OverAllRating } from "./talent.type";

export const useTalentsQuery = (page: number, searchTerm: string) => {
  const { data, error, isLoading, mutate } = useSWR<any, AxiosError, any>(
    [`/admin/getDevelopersList`, `?page=${page}&searchBy=${searchTerm}`],
    ([url, queryParams]: [string, string]) =>
      axiosInstance.get(url + queryParams).then((res) => res.data.data)
  );

  return {
    talents: data,
    isLoading,
    error,
    getTalents: mutate,
  };
};

export const useRematchMutation = (jobId: string) => {
  const { data, trigger, isMutating, error } = useSWRMutation<
    any,
    AxiosError,
    string,
    any,
    any
  >(`/admin/rematch/${jobId}`, (url: string, { arg }) =>
    axiosInstance.put(url, arg).then((res) => res.data)
  );

  return {
    data,
    isLoading: isMutating,
    rematchTalents: trigger,
  };
};

export const useUserOverallRatingQuery = (talentId: string) => {
  const { data, error, isLoading, mutate } = useSWR<
    OverAllRating,
    AxiosError,
    string
  >(`/comp/getTalentOverallRating/${talentId}`, (url: string) =>
    axiosInstance.get(url).then((res) => res.data?.data)
  );

  return {
    overallRating: data,
    isLoading,
    error,
    getOverAllRating: mutate,
  };
};

export const useTalentCbtDetailsQuery = (talentId: string) => {
  const { data, error, isLoading, mutate } = useSWR<
    CbtDetails,
    AxiosError,
    string
  >(`/comp/getATalentsCbtDetails/${talentId}`, (url: string) =>
    axiosInstance.get(url).then((res) => res.data?.data)
  );

  return {
    talentCbtDetails: data as any,
    isLoading,
    error,
    getTalentCbtDetails: mutate,
  };
};


export const useAllContentCreatorQuery = (id: string | null) => {
    const { data, error, isLoading, mutate } = useSWR<
      any,
      AxiosError,
      string | null
    >(
      id ? `/content-creator/list/${id}` : null,
      (url: string) => axiosInstance.get(url).then((res) => res.data),
      {
        revalidateOnFocus: true,
        revalidateOnMount: true,
      }
    )

    return {
      data: data,
      error,
      isLoading,
      mutate,
    };
}

export const useContentCreatorKpiQuery = (id: string | null) => {
    const { data, error, isLoading, mutate } = useSWR<any, AxiosError, string | null>(
      id ? `/content-creator/kpi/${id}` : null,
      (url: string) => axiosInstance.get(url).then((res) => res.data),
      {
        revalidateOnFocus: true,
        revalidateOnMount: true,
      }
    );

    return {
      data: data,
      error,
      isLoading,
      mutate,
    };
}